var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestoration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "backup-restore_svgrepo.com",
    clipPath: "url(#clip0_6293_9855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5 14.666H4.5V15.9993H20.5V14.666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.5002 17.334H17.8335V18.6673H20.5002V17.334Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.5697 10.0099L13.371 12.2029L13.3076 4.9948C13.3063 4.84774 13.2466 4.70722 13.1417 4.60415C13.0368 4.50109 12.8953 4.44391 12.7482 4.4452C12.6012 4.4465 12.4607 4.50615 12.3576 4.61105C12.2545 4.71595 12.1974 4.85749 12.1986 5.00455L12.262 12.2127L10.0249 10.042C9.97166 9.99222 9.90915 9.95342 9.84092 9.9278C9.77269 9.90218 9.70008 9.89026 9.62724 9.8927C9.55441 9.89514 9.48276 9.91191 9.4164 9.94204C9.35004 9.97217 9.29027 10.0151 9.24049 10.0683C9.19071 10.1215 9.15191 10.1841 9.12629 10.2523C9.10067 10.3205 9.08875 10.3931 9.09119 10.466C9.09363 10.5388 9.1104 10.6104 9.14053 10.6768C9.17066 10.7432 9.21357 10.8029 9.2668 10.8527L12.8352 14.3369L16.3474 10.7904C16.4323 10.684 16.4751 10.5501 16.4676 10.4141C16.4602 10.2781 16.4029 10.1497 16.3068 10.0532C16.2107 9.95675 16.0825 9.89902 15.9465 9.89103C15.8106 9.88304 15.6765 9.92534 15.5697 10.0099Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.0602 8.91237C20.9771 8.64177 20.8076 8.40589 20.5776 8.24091C20.3476 8.07593 20.0698 7.99096 19.7868 7.99904H14.5002V9.33238H19.8002C20.5002 11.2924 21.6468 14.4324 21.8335 14.9857V19.999H3.16683V14.9857C3.3535 14.4324 5.20016 9.33238 5.20016 9.33238H10.5002V7.99904H5.2135C4.9354 7.98807 4.6613 8.06804 4.43274 8.22684C4.20417 8.38563 4.03359 8.6146 3.94683 8.87904C1.8335 14.6657 1.8335 14.7324 1.8335 14.8857V19.999C1.8335 20.3527 1.97397 20.6918 2.22402 20.9419C2.47407 21.1919 2.81321 21.3324 3.16683 21.3324H21.8335C22.1871 21.3324 22.5263 21.1919 22.7763 20.9419C23.0264 20.6918 23.1668 20.3527 23.1668 19.999V14.8857C23.1668 14.7324 23.1668 14.6657 21.0602 8.91237Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6293_9855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoration);
export default __webpack_public_path__ + "static/media/Restoration.1b045d2cfd96aaf515a4e94d5561b141.svg";
export { ForwardRef as ReactComponent };